module.exports = __webpack_public_path__ + "media/Loops 90 Strings.02f7548e.wav";